export default "__VITE_PUBLIC_ASSET__ec7c1655__"